import { JSX, useState } from 'react';
import { styled } from '@mui/system';
import {
	DataGrid,
	GridRowSelectionModel,
	GridRowIdGetter,
	GridToolbar,
	GridCallbackDetails,
} from '@mui/x-data-grid';

/* eslint-disable */
interface LocalDataGridProps {
	rows: any[];
	columns: any[];
	getRowId: GridRowIdGetter<any> | undefined;
	onPageChange?: (page: number) => void;
	onPageSizeChange?: (pageSize: number) => void;
	pagination?: boolean;
	NoRowMessage?: JSX.Element;
	onSelectionModelChange?:
		| ((
				selectionModel: GridRowSelectionModel,
				details: GridCallbackDetails<any>
		  ) => void)
		| undefined;
	checkboxSelection?: boolean;
	selectionModel?: GridRowSelectionModel;
	rowSpanning?: boolean;
	disableColumnSorting?: boolean;
}
/* eslint-enable */

/**
 * @deprecated This component should not be used anymore. Please use AppDataGrid instead.
 */
export default function LocalDataGrid({
	rows,
	columns,
	getRowId,
	onPageChange,
	onPageSizeChange,
	pagination,
	onSelectionModelChange,
	NoRowMessage,
	checkboxSelection,
	selectionModel,
	rowSpanning,
	disableColumnSorting = true,
}: LocalDataGridProps) {
	const initialPageSize = 20;
	const initialPage = 0;
	const [page, setPage] = useState<number>(initialPage);
	const [pageSize, setPageSize] = useState<number>(initialPageSize);

	return (
		<StyledDataGrid
			disableColumnSorting={disableColumnSorting}
			rows={rows}
			columns={columns}
			getRowId={getRowId}
			hideFooter={pagination == null || pagination == true ? false : true}
			pagination={pagination ? pagination : true}
			disableRowSelectionOnClick
			disableColumnFilter
			disableColumnSelector
			disableDensitySelector
			disableColumnMenu
			autoHeight
			rowSpanning={rowSpanning}
			checkboxSelection={checkboxSelection ?? false}
			columnHeaderHeight={56}
			getRowHeight={() => 'auto'}
			onRowSelectionModelChange={onSelectionModelChange}
			rowSelectionModel={selectionModel}
		/>
	);
}

const StyledDataGrid = styled(DataGrid)(() => ({
	border: 0,
	borderBottom: '1px solid #E0E0E0',
	'& .css-yseucu-MuiDataGrid-columnHeaderRow': {
		height: 'auto !important',
		minHeight: '56px',
	},
	'& .MuiDataGrid-columnHeaderTitle': {
		fontWeight: 'normal',
		whiteSpace: 'normal !important',
		wordWrap: 'break-word',
		overflow: 'visible !important',
		paddingTop: '8px',
		paddingBottom: '8px',
	},
	'& .MuiDataGrid-columnHeaders': {
		backgroundColor: '#EEF1F6',
		fontWeight: 'normal',
		height: 'auto !important',
		minHeight: '56px',
	},
	'--DataGrid-t-header-background-base': '#fafafa!important',
	'& .MuiDataGrid-columnSeparator': {
		visibility: 'hidden',
	},
	'& .MuiDataGrid-iconButtonContainer button': {
		display: 'none',
	},
	'& .MuiDataGrid-cell': {
		display: 'flex',
		alignItems: 'center',
		paddingTop: '10px',
		paddingBottom: '10px',
	},
}));
